import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CartService {
  public isCartOpen = new BehaviorSubject<boolean>(false);

  public openCart(): void {
    this.isCartOpen.next(true);
  }

  public closeCart(): void {
    this.isCartOpen.next(false);
  }
}
